class OpenSCADError extends Error {
  code: string;
  stdErr: string[];
  stdOut: string[];

  constructor(
    message: string,
    code: string,
    stdErr: string[],
    stdOut: string[] = [],
  ) {
    super(message);
    this.code = code;
    this.stdErr = stdErr;
    this.stdOut = stdOut;
  }
}

export default OpenSCADError;
